import styled from "styled-components";

import { Small } from "utils/styling/typography.styled";

export const TooltipContainer = styled.div`
    width: 100%;
    max-width: 10rem;
    padding: 0.5rem;
    box-sizing: border-box;
    word-wrap: break-word;
`;

export const TooltipText = styled(Small)`
    display: block;
    margin-bottom: 0.5rem;
`;
